/**
 * Typography used in theme

 */

export default function themeTypography(theme) {
  return {
    fontFamily: `'Open Sans', sans-serif`,
    h6: {
      fontWeight: 500,
      color: theme.heading,
      fontSize: "0.7rem",
    },
    h5: {
      fontSize: "0.8rem",
      color: theme.heading,
      fontWeight: 500,
    },
    h4: {
      fontSize: "0.875rem",
      color: theme.heading,
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.05rem",
      color: theme.heading,
      fontWeight: 600,
    },
    h2: {
      fontSize: "1.25rem",
      color: theme.heading,
      fontWeight: 700,
    },
    h1: {
      fontSize: "1.75rem",
      color: theme.heading,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: "0.875rem",
      fontWeight: 500,
      color: theme.textDark,
    },
    subtitle2: {
      fontSize: "0.75rem",
      fontWeight: 400,
      color: theme.darkTextSecondary,
    },
    caption: {
      fontSize: "0.75rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    body1: {
      fontSize: "0.85rem",
      fontWeight: 400,
      lineHeight: "1.25em",
    },
    body2: {
      letterSpacing: "0em",
      fontWeight: 400,
      lineHeight: "1.35em",
      color: theme.darkTextPrimary,
    },
    button: {
      textTransform: "capitalize",
    },
    customInput: {
      marginTop: 1,
      marginBottom: 1,
      "& > label": {
        top: 23,
        left: 0,
        color: theme.grey500,
        '&[data-shrink="false"]': {
          top: 5,
        },
      },
      "& > div > input": {
        padding: "30.5px 14px 11.5px !important",
      },
      "& legend": {
        display: "none",
      },
      "& fieldset": {
        top: 0,
      },
    },
    mainContent: {
      backgroundColor: theme.background,
      width: "100%",
      minHeight: "calc(100vh - 60px)",
      flexGrow: 1,
      padding: "10px",
      marginTop: "60px",
      marginRight: "8px",
      borderRadius: `8px`,
    },
    menuCaption: {
      fontSize: "0.78rem",
      fontWeight: 500,
      color: theme.heading,
      padding: "4px",
      textTransform: "capitalize",
      marginTop: "6px",
    },
    subMenuCaption: {
      fontSize: "0.625rem",
      fontWeight: 500,
      color: theme.darkTextSecondary,
      textTransform: "capitalize",
    },
    commonAvatar: {
      cursor: "pointer",
      borderRadius: "8px",
    },
    smallAvatar: {
      width: "22px",
      height: "22px",
      fontSize: "1rem",
    },
    mediumAvatar: {
      width: "34px",
      height: "34px",
      fontSize: "1.2rem",
    },
    largeAvatar: {
      width: "44px",
      height: "44px",
      fontSize: "1.5rem",
    },
  };
}
